import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { PartnerAnalysisGroup4 } from 'src/app/assabil-kernel/models/entities/control-tables/partner-analysis-group4';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PartnerAnalysisGroup4Request } from 'src/app/assabil-kernel/models/dtos/control-tables/partner-analysis-group4-request';


@Component({
  selector: 'app-partner-analysis-group4-list',
  templateUrl: './partner-analysis-group4-list.component.html',
  styleUrls: ['./partner-analysis-group4-list.component.scss']
})
export class PartnerAnalysisGroup4ListComponent extends BasePage2<PartnerAnalysisGroup4> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  partnersAnalysisGroups: PartnerAnalysisGroup4[] = [];
  // ---------------------------------------------------
  

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'partnerAnalysisGroup4';
  }


  listFields = [
      { prop: 'partnerAnalysisGroup4Code', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'rank', name: 'Rang' }
  ]

  getRows(): PartnerAnalysisGroup4[] {
      return this.partnersAnalysisGroups;
  }
  //----------------------------------------------------------------------
  new(){
    let entity : PartnerAnalysisGroup4 = new PartnerAnalysisGroup4();
    entity.inserted = true;
    entity.edit = true;
    this.partnersAnalysisGroups.push(entity);
    this.partnersAnalysisGroups = [...this.partnersAnalysisGroups];
    }
//----------------------------------------------------------------------

//----------------------------------------------------------------------
saveRow(partnerAnalysisGroup4: PartnerAnalysisGroup4): Promise<PartnerAnalysisGroup4> {
  let request  : PartnerAnalysisGroup4Request = new PartnerAnalysisGroup4Request(this.controlService.getUserInfo());
  request.partnerAnalysisGroup4 = partnerAnalysisGroup4;
    return this.controlService.save(this.entityName, request);
}
//----------------------------------------------------------------------


  loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.partnersAnalysisGroups = result;
        
    }).catch(error => {
        this.showError(error);
    })
  }

  }
